import { Request } from '../lib';

export default {
  profile: () => {
    return Request.get('/users/profile')
  }
};
